import { useApi } from '@/api'

export const useOrganizationsResource = () => {
  const api = useApi()
  const organizations = api.api.v1.organizations

  return {
    getOrganizations: () => organizations.get(),
    getOrganization: (organizationId: string) => organizations({ organizationId }).get(),
    setOrganizationName: (organizationId: string, name: string) => organizations({ organizationId }).patch({ name })
  }
}
